module.exports = __webpack_public_path__ + "assets/img/merchant.515e957a.png";